export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9462.800842bd.jpg";